import { auth } from '../../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { v4 as uuidv4 } from 'uuid';

const reTriggerDealHighlights = (orgId, dealId, adminId, callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'TRIGGERING_DEAL_HIGHLIGHTS_GENERATION' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/ads/org/${orgId}/deals/${dealId}/deal-highlights-retrigger`,
            null,
            {
              params: {
                'request-id': reqId,
                orgAdminUserId: adminId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'TRIGGERING_DEAL_HIGHLIGHTS_GENERATION_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'TRIGGERING_DEAL_HIGHLIGHTS_GENERATION_FAILED',
              payload: `Failed to trigger deal highlights generation`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'TRIGGERING_DEAL_HIGHLIGHTS_GENERATION_FAILED',
            payload: `Failed to trigger deal highlights generation`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'TRIGGERING_DEAL_HIGHLIGHTS_GENERATION_FAILED',
        payload: `Failed to trigger deal highlights generation`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default reTriggerDealHighlights;
